import ConsumerClaimPanel from "./consumerClaimPanel.container";

export default ConsumerClaimPanel;
